import { Theme } from '@radix-ui/themes';
import React, { ReactNode, useEffect } from 'react';
import { useThemePreferencesProperties } from './UseThemePreferences';
import { useAppDispatch } from '../../hooks/hooks';
import { setLoaderAvailable } from '../../redux/slices/loaderController';

interface ThemeProviderProps {
  children: ReactNode;
}

const DEFAULT_THEME = {
  appearance: 'light' as const,
  accentColor: 'orange' as const,
  grayColor: 'sand' as const,
  radius: 'full' as const,
  scaling: '110%' as const,
};

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const { data: themeData, isLoading } = useThemePreferencesProperties();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setLoaderAvailable(isLoading));
  }, [isLoading, dispatch]);

  const themeProps = {
    appearance: (themeData?.appearance || DEFAULT_THEME.appearance) as any,
    accentColor: (themeData?.accentColor || DEFAULT_THEME.accentColor) as any,
    grayColor: (themeData?.grayColor || DEFAULT_THEME.grayColor) as any,
    radius: (themeData?.radius || DEFAULT_THEME.radius) as any,
    scaling: (themeData?.scaling || DEFAULT_THEME.scaling) as any,
  };

  return <Theme {...themeProps}>{children}</Theme>;
};